/* eslint-disable camelcase */
import { useMemo, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames  from 'classnames';
import { getRandomID } from '@mdc/services';

import './MitreSubtechniques.scss';

const MitreSubtechniques = ({ techniques, subtechniqueId, techniqueId, onSubtechniqueClick }) => {
    const [buttonTooltipId] = useState(`MitreSubtechniqueTooltip${getRandomID(5)}`);
    const [isSubtechniqueOpened, setIsSubtechniqueOpened] = useState(false);

    const iconClassName = classNames({
        'isOpen': isSubtechniqueOpened
    }, 'iconWrapper');

    const handleClick = () => {
        setIsSubtechniqueOpened(!isSubtechniqueOpened);
    };

    const renderTooltip = (props, ttpTechniqueId) => (
        <Tooltip id={buttonTooltipId} {...props} className='mitreTooltip'>
            {ttpTechniqueId}
        </Tooltip>
    );

    const subtechniquesDom = useMemo(() => {
        if (!isSubtechniqueOpened) {
            return;
        }

        const ttp = {
            technique_id: `${techniqueId}.${subtechniqueId}`,
            name: techniques?.name
        };

        return <div className='tdSubtechniques'>
            <OverlayTrigger
                placement='top'
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => renderTooltip(props, ttp.technique_id)}
            >
                <Button className='subtechniqueButton' onClick={(event) => onSubtechniqueClick(event, ttp)}>
                    {techniques?.name}
                </Button>
            </OverlayTrigger>
        </div>;

    }, [techniques, isSubtechniqueOpened]);

    return (
        <div className='mitreSubtechniques'>
            <div className='tdChildren' onClick={handleClick}>
                <div className={iconClassName}>
                    <i className='icon icon-line'/>
                    <i className='icon icon-line'/>
                </div>
            </div>
            {subtechniquesDom}
        </div>
    );
};

MitreSubtechniques.defaultProps = {
    size: 'md'
};

MitreSubtechniques.propTypes = {
    techniques: PropTypes.object.isRequired,
    subtechniqueId: PropTypes.string,
    techniqueId: PropTypes.string,
    onSubtechniqueClick: PropTypes.func
};

export default MitreSubtechniques;
